import { Link } from 'react-router-dom';
import { todayUpdates, latestNews } from '@/mocks/site';

const tagColor: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="latest" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-accent-600">
              <span className="inline-block h-2 w-2 rounded-full bg-accent-500"></span>今日抢先看
            </p>
            <h2 className="font-heading mt-3 text-2xl text-foreground-950 md:text-4xl">
              今日更新 · 抢先看最新话
            </h2>
          </div>
          <Link to="/comics" className="flex items-center whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700">
            浏览漫画库 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 lg:col-span-2">
            <h3 className="text-sm font-bold text-foreground-950">今日更新时间线</h3>
            <ul className="mt-4 space-y-1">
              {todayUpdates.map((u, i) => (
                <li
                  key={i}
                  className="flex items-center gap-4 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
                >
                  <span className="w-12 shrink-0 text-xs font-bold text-foreground-500">{u.time}</span>
                  <span className={`whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${tagColor[u.tagColor]}`}>
                    {u.tag}
                  </span>
                  <span className="truncate text-sm text-foreground-800">{u.title}</span>
                  <i className="ri-arrow-right-line ml-auto shrink-0 text-foreground-300"></i>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="text-sm font-bold text-foreground-950">更新速报</h3>
            {latestNews.slice(0, 3).map((n) => (
              <article
                key={n.id}
                className="group rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:-translate-y-1"
              >
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 font-medium text-accent-800">
                    {n.category}
                  </span>
                  <span>{n.date}</span>
                </div>
                <h4 className="mt-3 text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
                  {n.title}
                </h4>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                  {n.excerpt}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}